<template>
  <div class='YPrint'>
    <div class="boxasdf">
      <slot></slot>
      <div class="block" ref="block">
        <el-timeline>
          <el-timeline-item :timestamp="item.startTime ? item.startTime : item.createTime" placement="top" v-for="item in jobAuditRecords" :key="item.id">
            <el-card>
              <div class="box">
                <img class="img" :src="item.images ? item.images : 'https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/ODC/odc-web/default_img.png'" alt="">
                <div class="info">
                  <div class="title">{{item.auditObjectName}}</div>
                  <div class="main">{{item.content}}</div>
                </div>
                <div class="result">{{item.result.name}}</div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div class="btn" v-if="btnShow">
      <el-button type='primary' round @click="print">打印</el-button>
      <el-button plain round @click="close">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YPrint',

  props: {
    jobAuditRecords: {
      type: Array,
      default () {
        return []
      }
    }
  },

  data () {
    return {
      btnShow: true
    }
  },

  methods: {
    print () {
      this.btnShow = false
      setTimeout(res => {
        window.print()
        this.btnShow = true
      })
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='stylus' scoped>
  .YPrint
    position fixed
    width 100%
    height 100%
    background #ffffff
    top 0
    left 0
    padding 60px
    box-sizing border-box
    overflow auto
    z-index 1
    .boxasdf
      border 1px solid #dbe3ef
      padding 80px
      border-radius 20px
    .block
      margin-right 20px
      .box
        display flex
        position relative
        .img
          width 100px
          height 100px
          margin-right 20px
        .info
          display flex
          flex-direction column
          justify-content center
          .title
            font-size 26px
            font-weight bold
          .main
            margin-top 10px
            font-size 22px
        .result
          position absolute
          height 100%
          right 0
          display flex
          align-items center
          justify-content center
          color #67c23a
    .btn
      margin 20px 0
      text-align center
</style>
